import { createContext } from 'react';

import { OtpContextType } from './OtpContext.types';

export const OtpContext = createContext<OtpContextType | undefined>(undefined);
